import Vue from 'vue'

export const snackbar = Vue.observable({
  show: false,
  text: '',
  color: 'error', // 'error', 'info'
  close_btn: '',
  secondary_btn: '',
  timeout: 30000,
})

export function showSnackbar(text, color, timeout, close_btn, secondary_btn) {
  snackbar.text = text
  snackbar.color = color
  snackbar.timeout = timeout
  snackbar.close_btn = close_btn
  snackbar.secondary_btn = secondary_btn
  snackbar.show = true
}
